/**
 * Build marker — baked in at build time.
 */
export const BUILD_ITER = "iter-158.13.2.16";
export const BUILD_NOTE = "Iter-158.13.2.4 — Department-scoped shareable invite. Copy Link + QR + Email are now three ways to share the SAME dept-scoped invitation. New reusable shareable invitation record per (project, department); shareable role is capped at contributor; a Regenerate Link button in Settings rotates the code and immediately invalidates the previous URL. Production Hub invite surface deferred.";
export const BUILD_AT = new Date().toISOString().slice(0, 10);
